var _defs, _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgQuran(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "20px",
    height: "20px",
    viewBox: "0 0 48 48",
    id: "b",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\r\n  .c {\r\n    fill: none;\r\n    stroke: currentColor;\r\n    stroke-linecap: round;\r\n    stroke-linejoin: round;\r\n    stroke-width: 2;\r\n  }\r\n"))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "m24,15.1226c1.2237-1.804,5.4857-4.684,8.7139-4.7473l5.5068,15.4128c-3.7978.9811-10.3701,3.6712-14.2207,7.4057-3.8506-3.7345-10.4229-6.4246-14.2207-7.4057l5.5068-15.4128c3.2281.0633,7.4901,2.9433,8.7139,4.7473Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "m33.4207,12.3536l4.1038,1.2815,4.8941,13.7502c.2404.6754-.0675,1.4234-.7137,1.7339l-17.7048,8.5055L6.2952,29.1192c-.6462-.3105-.9541-1.0584-.7137-1.7339l4.8941-13.7502,4.1038-1.2815"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgQuran);
export default __webpack_public_path__ + "static/media/quran.27e6aa62c317428dbfbcb2c8d09b3e7c.svg";
export { ForwardRef as ReactComponent };